import { propertyBasicAPI } from '../api/propertyApi'
import { HttpResponse } from '../interfaces/googleMapsInterfaces'
import { DefaultSearch, ZoneCoincidence } from '../interfaces/zoneInterface'
import { presenter } from '@wiggot/core-apis/src/presenter/index'

export const getZoneCoincidences = async (params: {
  text: string
}): Promise<HttpResponse<ZoneCoincidence[]>> => {
  try {
    const { text } = params

    const response = await propertyBasicAPI.get<any>(
      `/listings-properties/autocomplete/zones?search=${text}`
    )

    const nomenclature = presenter({
      style: 'camel',
      value: response?.data
    })

    return {
      isSuccess: true,
      data: nomenclature
    }
  } catch (error) {
    return {
      isSuccess: false,
      error: {
        message: 'Error al obtener las zonas',
        code: 'error_getting_zones',
        data: error
      }
    }
  }
}

export const getZoneCoincidencesByLocation = async (params: {
  latitude: number
  longitude: number
  deviceId: string
  sessionId: string
  userId: string
}): Promise<HttpResponse<DefaultSearch[]>> => {
  try {
    const { latitude, longitude, deviceId, sessionId, userId } = params

    const response = await propertyBasicAPI.get<{
      data: DefaultSearch[]
    }>(
      `/monopolio-data/v1/users-search/suggestions?userLatitude=${latitude}&userLongitude=${longitude}&deviceId=${deviceId}&sessionId=${sessionId}&userId=${userId}`
    )

    const nomenclature = presenter({
      style: 'camel',
      value: response?.data
    })

    const defaultSearches: DefaultSearch[] = nomenclature.map(
      (item: any): DefaultSearch => ({
        name: item?.addressRecommendation,
        id: item?.polygon.id,
        type: item?.polygon.type,
        coordinates: item?.centroid
      })
    )

    return {
      isSuccess: true,
      data: defaultSearches
    }
  } catch (error) {
    return {
      isSuccess: false,
      error: {
        message: 'Error al obtener las zonas',
        code: 'error_getting_zones',
        data: error
      }
    }
  }
}
